/** Comma-, space- or semicolon-separated addresses, lower-cased and deduplicated; the first is canonical. */
export function parseAddresses(raw: string): readonly string[] {
  return [
    ...new Set(
      raw
        .split(/[\s,;]+/)
        .map((a) => a.trim().toLowerCase())
        .filter((a) => a.includes('@')),
    ),
  ]
}
